import {useCallback, useEffect, useMemo, useState} from "react";
import {useAppBridge} from "@shopify/app-bridge-react";
import {Frame} from "@shopify/polaris";
import {Navigate, Route, Routes, useLocation, useNavigate} from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Help from "./pages/Help";
import ShopApp from "./pages/ShopApp";
import Install from "./pages/Install";
import StartOnboarding from "./pages/Onboarding/StartOnboarding";
import Plan from "./pages/Onboarding/Plan";
import Installer from "./pages/Onboarding/Installer";
import GetStarted from "./pages/Onboarding/GetStarted";
import Design from "./pages/Design";
import BulkHelp from "./pages/BulkHelp";
import PremadeCharts from "./pages/PremadeCharts";
import ChartForm from "./pages/Chart/ChartForm";
import Preview from "@admin/pages/Preview";
import PageSkeleton from "@admin/components/PageSkeleton";
import {Redirect} from "@shopify/app-bridge/actions";
import { initWebVitals } from '@admin/Lib/sendWebVitals';
import SizingSync from "@admin/pages/SizingSync";
import Style from "@admin/pages/Onboarding/Style";



function App() {

    const location = useLocation();
    const navigate = useNavigate();

    // @ts-ignore
    if (window.appUpdateRequired) {
        const redirect = Redirect.create(window.app);
        // @ts-ignore
        redirect.dispatch(Redirect.Action.REMOTE, window.appUpdateUrl);
        return <PageSkeleton />;
    }

    // Adapt between the new navigation API and the old history API that app-bridge expects
    const history = useMemo(() => ({
        replace: (path: string) => navigate(path, {replace: true})
    }), []);



    const [mobileNavActive, setMobileNavActive] = useState(false);
    const toggleMobileNavActive = useCallback(() => setMobileNavActive(active => !active), []);



    return (
        <Frame
            showMobileNavigation={mobileNavActive}
            onNavigationDismiss={toggleMobileNavActive}>
            <Routes>
                <Route index element={<Navigate to="/app" replace/>}></Route>
                <Route path="/app">
                    <Route index element={<Dashboard/>}/>
                    <Route path="premade" element={<PremadeCharts/>}/>
                    <Route path="charts/new" element={<ChartForm/>}/>
                    <Route path="charts/:chartID" element={<ChartForm/>}/>
                    <Route path="preview/:chartID" element={<Preview/>}/>
                    <Route path="help" element={<Help/>}/>
                    <Route path="data" element={<SizingSync/>}/>
                    <Route path="bulk-help" element={<BulkHelp/>}/>
                    <Route path="install" element={<Install/>}/>
                    <Route path="shop" element={<ShopApp/>}/>
                    <Route path="settings" element={<Design/>}/>
                    <Route path="wizard/1" element={<StartOnboarding/>}/>
                    <Route path="wizard/2" element={<Plan/>}/>
                    <Route path="wizard/3" element={<Installer/>}/>
                    <Route path="wizard/4" element={<Style/>}/>
                    <Route path="wizard/5" element={<GetStarted/>}/>
                </Route>
            </Routes>
        </Frame>
    );
}

export default App;
